import { ReactNode, useEffect, useState } from "react";
import { Card, Space } from "antd";
import { ExclamationCircleOutlined } from '@ant-design/icons';

interface CardStyle {
    color: string;
    borderLeft: string;
    backgroundColor: string;
}
export interface MessageCardProps {
    type: "info" | "error" | "neutral" | "domain-info";
    text: ReactNode;
    extra?: ReactNode;
    style?: object;
    displayExclamationIcon?: boolean;
}

const MessageCard = ({ text, type, extra, style = {}, displayExclamationIcon = true }: MessageCardProps) => {
    const [cardStyle, setCardStyle] = useState<CardStyle>();

    useEffect(() => {
        formatStyle(type);
    }, [type])

    const formatStyle = (type: "info" | "error" | "neutral" | "domain-info") => {
        switch (type) {
            case "info":
                return setCardStyle({
                    color: "#3399ff",
                    borderLeft: "5px solid #3399ff",
                    backgroundColor: "#cce5ff"
                });
            case "error":
                return setCardStyle({
                    color: "red",
                    borderLeft: "5px solid red",
                    backgroundColor: "#ffe6e6"
                });
            case "neutral":
                return setCardStyle({
                    color: "gray",
                    borderLeft: "5px solid gray",
                    backgroundColor: "whitesmoke"
                });
            case "domain-info":
                return setCardStyle({
                    color: "#3399ff",
                    borderLeft: "5px solid #3399ff",
                    backgroundColor: "#3899ff1f"

                });
        }
    }

    return (
        <Card
            bordered={false}
            style={{
                borderLeft: cardStyle?.borderLeft,
                backgroundColor: cardStyle?.backgroundColor,
                ...style
            }}
            key="messageCard"
        >
            <Space>
                {
                    !!displayExclamationIcon ?
                        <ExclamationCircleOutlined style={{ color: cardStyle?.color, fontSize: 28 }} /> :
                        null
                }
                {text}
            </Space>
            {extra}
        </Card>
    )
}

export default MessageCard;